/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Service_1Inputs */

const da_terms_service_1 = /** @type {(inputs: Terms_Service_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AImforA giver forslag til point, karakter og feedback på elevopgaver ud fra den rettevejledning, læreren uploader. Forslagene er et støtteværktøj: **læreren gennemgår og godkender altid** og er ansvarlig for bedømmelsen. AI kan tage fejl. Tjenesten må ikke bruges til den officielle bedømmelse af folkeskolens prøver.`)
};

/** @type {(inputs: Terms_Service_1Inputs) => LocalizedString} */
const en_terms_service_1 = da_terms_service_1;

/**

* @param {Terms_Service_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_service_1 = /** @type {((inputs?: Terms_Service_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Service_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_service_1(inputs)
	return /** @type {LocalizedString} */ ("AImforA giver forslag til point, karakter og feedback på elevopgaver ud fra den rettevejledning, læreren uploader. Forslagene er et støtteværktøj: **læreren gennemgår og godkender altid** og er ansvarlig for bedømmelsen. AI kan tage fejl. Tjenesten må ikke bruges til den officielle bedømmelse af folkeskolens prøver.")
});